/**
 * Layout component that queries for data
 * with Gatsby's StaticQuery component
 *
 * See: https://www.gatsbyjs.org/docs/static-query/
 */

import "./layout.css";

import React, { useEffect, useState } from "react";
import { StaticQuery, graphql } from "gatsby";

import Header from "./header/header";
import PropTypes from "prop-types";

function Layout({ children }) {
  const [theme, setTheme] = useState("light");

  function toggleTheme() {
    theme === "light" ? setTheme("dark") : setTheme("light");

    document.documentElement.setAttribute("data-theme", theme);
  }

  return (
    <StaticQuery
      query={graphql`
        query SiteTitleQuery {
          site {
            siteMetadata {
              title
              social {
                linkedin
                twitter
              }
            }
          }
        }
      `}
      render={data => (
        <div className="da-wrapper">
          <Header
            theme={theme}
            siteTitle={data.site.siteMetadata.title}
            social={data.site.siteMetadata.social}
          />
          <div
            style={{
              margin: `0 auto`,
              maxWidth: 960,
              padding: `0px 1.0875rem 1.45rem`,
              paddingTop: 0,
              backgroundColor: "#f7f8fc",
            }}
          >
            <main style={{ paddingTop: 32 }}>{children}</main>
            <footer style={{ fontFamily: "Roboto" }}>
              © {new Date().getFullYear()}, Built with
              {` `}
              <a href="https://www.gatsbyjs.org">Gatsby</a>
            </footer>
          </div>
        </div>
      )}
    />
  );
}

Layout.propTypes = {
  children: PropTypes.node.isRequired,
};

export default Layout;
